module.exports = __webpack_public_path__ + "img/loading2.1d19762b.png";